import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_button = _resolveComponent("radio-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.question) + " ", 1),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["btn-group", _ctx.optionsWidth]),
      role: "group",
      "aria-label": _ctx.name + 'option',
      style: _normalizeStyle({ pointerEvents: _ctx.disabled ? 'none' : 'auto', opacity: _ctx.disabled ? '0.65' : '1' })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, i) => {
        return (_openBlock(), _createBlock(_component_radio_button, {
          ref_for: true,
          ref: _ctx.name + i,
          key: i,
          name: _ctx.name + 'GroupName',
          label: item,
          value: _ctx.selected,
          onChange: _ctx.onChange
        }, null, 8, ["name", "label", "value", "onChange"]))
      }), 128))
    ], 14, _hoisted_1)
  ], 64))
}